export default "__VITE_ASSET__CS$jvqeJ__"